// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__X797L","sendMessageForm":"styles_sendMessageForm__EeUNO"};